import { Link, useRouterState } from "@tanstack/react-router";
import { Bell, Sun, Moon, Menu, ChevronRight, LogOut } from "lucide-react";
import { useTheme } from "@/lib/theme";
import { useAuth } from "@/lib/auth";
import { Avatar, AvatarFallback } from "@/components/ui/avatar";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabase";
const titles: any = {
  "/admin": "Dashboard",
  "/admin/analytics": "Analytics",
  "/admin/products": "Products",
  "/admin/orders": "Orders",
  "/admin/customers": "Customers",
  "/admin/inventory": "Inventory",
  "/admin/promotions": "Promotions",
  "/admin/finance": "Finance",
  "/admin/cms": "Content",
  "/admin/tickets": "Service Tickets",
  "/admin/technicians": "Technicians",
  "/admin/schedule": "Schedule",
};
export function AdminTopbar({
  onToggleSidebar,
}: {
  onToggleSidebar: () => void;
}) {
  const { theme, toggle } = useTheme(),
    { logout, user } = useAuth(),
    path = useRouterState({ select: (s) => s.location.pathname }),
    [count, setCount] = useState(0);
  useEffect(() => {
    if (user)
      supabase
        .from("notifications")
        .select("id", { count: "exact", head: true })
        .eq("user_id", user.id)
        .is("read_at", null)
        .then((x) => setCount(x.count || 0));
  }, [user]);
  return (
    <header className="sticky top-0 z-30 border-b border-border bg-background/90 backdrop-blur-xl">
      <div className="flex h-16 items-center gap-3 px-4 md:px-6">
        <button
          onClick={onToggleSidebar}
          className="grid h-9 w-9 place-items-center rounded-lg hover:bg-muted"
        >
          <Menu className="h-4 w-4" />
        </button>
        <nav className="hidden md:flex items-center text-sm text-muted-foreground">
          <Link to="/admin">KIZAK</Link>
          <ChevronRight className="mx-1.5 h-3.5 w-3.5" />
          <span className="font-medium text-foreground">
            {titles[path] || "Admin"}
          </span>
        </nav>
        <div className="ml-auto flex items-center gap-2">
          <button
            onClick={toggle}
            className="grid h-9 w-9 place-items-center rounded-lg border border-border"
          >
            {theme === "dark" ? <Sun size={16} /> : <Moon size={16} />}
          </button>
          <Link
            to="/shop"
            className="hidden sm:inline-flex rounded-lg border border-border px-3 py-2 text-xs"
          >
            Storefront
          </Link>
          <button className="relative grid h-9 w-9 place-items-center rounded-lg border border-border">
            <Bell size={16} />
            {count > 0 && (
              <span className="absolute right-1 top-1 h-2 w-2 rounded-full bg-primary" />
            )}
          </button>
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button className="flex items-center gap-2 rounded-lg p-1">
                <Avatar className="h-8 w-8">
                  <AvatarFallback>
                    {(user?.name || "KZ").slice(0, 2).toUpperCase()}
                  </AvatarFallback>
                </Avatar>
                <span className="hidden sm:block text-xs font-semibold">
                  {user?.name}
                </span>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuLabel>{user?.email}</DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem onClick={logout}>
                <LogOut className="mr-2 h-4 w-4" />
                Sign out
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}